<script setup>
import LocalLoader from "@/components/UI/LocalLoader.vue";
import {useStore} from "@/store";

defineProps({
  result: {
    type: [Object, null],
    required: true,
    default: null
  },
  hoverType: {
    type: [String, null],
    required: true
  }
});

const emit = defineEmits(["change-hover-type"]);

const store = useStore();
</script>

<template>
  <div class="ner-result">
    <div class="ner-result__title">
      Результат анализа
    </div>
    <div class="ner-result__area">
      <div
        v-if="store.isNerLoading"
        class="ner-result__loader"
      >
        <LocalLoader />
      </div>
      <div
        class="ner-result__summary"
      >
        <div
          v-if="!result.summary || result.summary.length === 0"
          class="ner-result__summary--empty"
        >
          Здесь будет краткое описание текста
        </div>

        <div
          v-else
          class="ner-result__summary--content scroll"
        >
          {{ result.summary }}
        </div>
      </div>
      <div
        class="ner-result__content scroll"
      >
        <div class="ner-result__category">
          <div
            class="ner-result__category_title"
            @mouseenter="emit('change-hover-type', 'person')"
            @mouseleave="emit('change-hover-type', null)"
          >
            Персоны ({{ result.persons.length }})
          </div>
          <div
            v-if="result.persons.length > 0"
            class="ner-result__list"
          >
            <div
              v-for="item in result.persons"
              :key="item"
              class="ner-result__item"
            >
              <span class="ner-result__item--bold">{{ item.name }}</span> - {{ item.description }}
            </div>
          </div>
          <div
            v-else
            class="ner-result__empty"
          >
            Нет персон для отображения
          </div>
        </div>
        <div class="ner-result__category">
          <div
            class="ner-result__category_title"
            @mouseenter="emit('change-hover-type', 'location')"
            @mouseleave="emit('change-hover-type', null)"
          >
            Места ({{ result.locations.length }})
          </div>
          <div
            v-if="result.locations.length > 0"
            class="ner-result__list"
          >
            <div
              v-for="item in result.locations"
              :key="item"
              class="ner-result__item"
            >
              {{ item }}
            </div>
          </div>
          <div
            v-else
            class="ner-result__empty"
          >
            Нет мест для отображения
          </div>
        </div>
        <div class="ner-result__category">
          <div
            class="ner-result__category_title"
            @mouseenter="emit('change-hover-type', 'organisation')"
            @mouseleave="emit('change-hover-type', null)"
          >
            Организации ({{ result.organisations.length }})
          </div>
          <div
            v-if="result.organisations.length > 0"
            class="ner-result__list"
          >
            <div
              v-for="item in result.organisations"
              :key="item"
              class="ner-result__item"
            >
              {{ item }}
            </div>
          </div>
          <div
            v-else
            class="ner-result__empty"
          >
            Нет организаций для отображения
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">



.ner-result {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(0.6px);
  }

  &__summary {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F7F8FD;
    padding: 20px 10px 20px 20px;
    border-radius: 10px;
    color: #7B87A5;
    font-size: 14px;
    font-weight: 400;
    height: 211px;

    &--content {
      max-height: calc(211px - 40px);
      padding-right: 10px;
    }
  }

  &__empty {
    padding: 0 15px;
    color: #7B87A5;
    font-size: 14px;
    font-weight: 400;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 15px;
  }

  &__item {
    font-size: 14px;
    font-weight: 400;

    &--bold {
      font-weight: 500;
    }
  }

  &__category {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &_title {
      display: inline-flex;
      align-self: flex-start;
      padding: 6.4px 15px;
      cursor: pointer;
      user-select: none;
      color: #7B87A5;
      border-radius: 20px;
      background: #F7F8FD;
      gap: 6px;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        font-weight: 500;
        color: #1F9AFF;
      }
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #212327;
  }

  &__area {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 30px;
    background: #FFFFFF;
    padding: 20px;
    border-radius: 8px;
    height: 100%;
    min-height: 0;
  }

  &__content {
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-right: 10px;
    gap: 10px;
    margin-right: 10px;

    &--empty {
      align-items: center;
      justify-content: center;
      color: #898989;
    }
  }
}

.highlight-person > .person-highlight {
  background: #FFE767;
}

.highlight-location > .location-highlight {
  background: #FFE767;
}

.highlight-organisation > .organisation-highlight {
  background: #FFE767;
}

.highlight-person > div .person-highlight {
  background: #FFE767;
}

.highlight-location > div .location-highlight {
  background: #FFE767;
}

.highlight-organisation > div .organisation-highlight {
  background: #FFE767;
}
</style>